namespace GeniuzPOS.CustomReport {
    export namespace ReportCusStockOnHandService {
        export const baseUrl = 'CustomReport/ReportCusStockOnHand';

        export declare function Create(request: Serenity.SaveRequest<ReportCusStockOnHandRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportCusStockOnHandRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportCusStockOnHandRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportCusStockOnHandRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomReport/ReportCusStockOnHand/Create",
            Update = "CustomReport/ReportCusStockOnHand/Update",
            Delete = "CustomReport/ReportCusStockOnHand/Delete",
            Retrieve = "CustomReport/ReportCusStockOnHand/Retrieve",
            List = "CustomReport/ReportCusStockOnHand/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportCusStockOnHandService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
